module.exports = __webpack_public_path__ + "static/media/us.a91ba47c.jpg";